import React from 'react';
import "./SendCoupons.css";
import { Col, Container, Row } from 'react-bootstrap';

function SendCoupons() {
  return (
    <section className="pb-lg-5 pt-4 margin-left">
      <Container fluid>
        <Row>
          <Col>
          <div className="dash-heading">
              <h5 className="fw-bold text-black">Send Coupons</h5>
              <p>??</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SendCoupons;